define('page/video-list', [
    'Vue',
    'utils/service',
    'utils/tools',
    'component/pagination/index'
], function (Vue, service, tools, vuePagination) {
    'use strict';
    new Vue({
        el: "#app",
        data: function () {
            return {
                video: {
                    list: [],
                    count: 0,
                    pageSize: 12,
                    pageIndex: 1
                },
                theme: {
                    list: [],
                    id: -1
                }
            }
        },
        methods: {
            getVideoList: function () {
                var video = this.video
                var pendData = service.getVideoList({
                    pageIndex: video.pageIndex,
                    pageSize: video.pageSize,
                    themeid: this.theme.id
                })

                pendData.then(function (res) {
                    if (res) {
                        video.count = res.count
                        video.list = res.data.map(function (item) {
                            return tools.toVaildData(['Title', 'PlayTimeStr', 'playcountformat', 'ImageUrl', 'Id'], item)
                        })
                    }
                })
            },
            getVideoThemeList: function () {
                var theme = this.theme
                var pendData = service.getVideoThemeList()

                pendData.then(function (res) {
                    if (res && Array.isArray(res)) {
                        theme.list = res.map(function (item) {
                            return tools.toVaildData(['Id', 'Name'], item)
                        })
                    }
                })
            },
            selectTheme: function (i) {
                this.theme.id = i
                tools.resetPageData(this, 'video.list', 'video.pageIndex')
                this.getVideoList()
            },
            updateVideoList: function (pageIndex) {
                this.video.pageIndex = pageIndex
                this.getVideoList()
            },
        },
        components: {
            'vue-pagination': vuePagination
        },
        beforeMount: function () { 
            this.getVideoList()
            this.getVideoThemeList()
        } 
    })
});
